import { useEffect } from 'react'
import FiberManualRecord from '@mui/icons-material/FiberManualRecord'
import { Button } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import FlagsPopover from './FlagsPopover'
import useFullFlagListData from './useFullFlagListData'

type ValidationFlagsButtonProps = {
  disableRowValueFlagClick?: boolean
}
export default function ValidationFlagsButton({
  disableRowValueFlagClick = false,
}: ValidationFlagsButtonProps) {
  const overlay = useOverlay()
  const {
    color,
    documentFlags,
    rowValueFlags,
    totalLength,
    onRowValueFlagClick,
  } = useFullFlagListData()

  useEffect(() => {
    if (!totalLength && overlay.isOpen) {
      overlay.close()
    }
  }, [overlay, totalLength])

  if (!totalLength) {
    return null
  }

  return (
    <>
      <Button
        color={color?.button}
        variant="text"
        startIcon={<FiberManualRecord sx={{ fontSize: 12 }} />}
        onClick={overlay.open}
        sx={{ flexShrink: 0 }}
      >
        {totalLength} Flag{totalLength > 1 ? 's' : ''}
      </Button>

      <FlagsPopover
        overlay={overlay}
        rowValueFlags={rowValueFlags}
        documentFlags={documentFlags}
        onRowValueFlagClick={
          disableRowValueFlagClick
            ? undefined
            : (...args) => {
                onRowValueFlagClick(...args)
                overlay.close()
              }
        }
      />
    </>
  )
}
